module.exports = {"TXTCLI_City":{"id":"TXTCLI_City","defaultMessage":"Ville","flags":["TRACK"],"track":"City"}}